<template>
    <DefaultHeader />
    <div class="container">
        <h4 class="mt-3">Créer client</h4>
        <div class="row mt-3">
            <div class="col-2">
                <div class="form-group">
                    <input v-model="name" type="text" class="form-control" placeholder="Nouveau client">
                </div>
            </div>
            <div class="col-2">
                <ButtonDisplay :type="'add'" text="Ajouter" @click="createClient()" />
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <span v-if="this.errorCreate" class="text-danger">Nom de client invalide</span>
            </div>
        </div>
        <hr />
        <h4 class="mt-3">Modifier le nom d'un client</h4>
        <div class="row mt-3">
            <div class="col-2">
                <div class="form-group">
                    <v-select v-model="selectedClientToUpdate" :options="clients" label="name"
                        :reduce="client => client.id" />
                </div>
            </div>
            <div class="col-2">
                <input v-model="newClientName" type="text" class="form-control" placeholder="Nouveau nom du client">
            </div>
            <div class="col-2">
                <ButtonDisplay :type="'edit'" text="Modifier" @click="updateSelectedClientName()"
                    :disabled="!selectedClientToUpdate" />
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <span v-if="this.errorMessage" class="text-danger">Nom de client invalide</span>
            </div>
        </div>
        <hr />

        <h4 class="mt-3">Verouiller/Déverrouiller un client</h4>
        <div class="row mt-3 d-flex align-items-center">
            <div class="col-2">
                <div class="form-group">
                    <v-select v-model="selectedClientToLock" :options="clients" label="name" />
                </div>
            </div>
            <div class="col-2">
                <ButtonDisplay :type="selectedClientToLock?.locked ? 'lock' : 'unlock'"
                    @click="updateSelectedClientLockState()" :disabled="!selectedClientToLock" />
            </div>
        </div>
        <div class="row">
            <div class="col-2">
                <span v-if="this.errorMessage" class="text-danger">Nom de client invalide</span>
            </div>
        </div>
        <hr />

        <h4 class="mt-3">Ajouter des SMS au client</h4>
        <div class="row mt-3">
            <div class="col-2">
                <select v-model="selectedClientSMS" class="form-select">
                    <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }}</option>
                </select>
            </div>
            <div class="col-2">
                <div class="form-group">
                    <input v-model="sms" type="text" class="form-control" placeholder="Nombre SMS">
                </div>
            </div>
            <div class="col-2">
                <ButtonDisplay :type="'add'" text="Ajouter" @click="addSms()" />
            </div>
        </div>
        <hr />
    </div>
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import ClientService from '@/services/client.service.js'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        ButtonDisplay,
    },
    data() {
        return {
            errorCreate: false,
            errorUpdate: false,
            errorLock: false,
            clients: [],
            name: "",
            selectedClientToUpdate: null,
            selectedClientToLock: null,
            newClientName: null,
            selectedClientSMS: null,
        };
    },
    mounted() {
        this.updateClients();
    },
    methods: {
        createClient() {
            if (!this.name) {
                this.errorCreate = true;
            } else {
                ClientService.createClient(this.name)
                    .then(() => {
                        this.name = "";
                        this.errorCreate = false;
                        this.updateClients();
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
        updateClients() {
            // Sauvegarde des sélections avant mise à jour
            const selectedUpdateId = this.selectedClientToUpdate
                ? this.selectedClientToUpdate.id || this.selectedClientToUpdate
                : null;
            const selectedLockId = this.selectedClientToLock
                ? this.selectedClientToLock.id || this.selectedClientToLock
                : null;
            ClientService.getClients()
                .then(response => {
                    this.clients = response.data;

                    // Réassocier les clients sélectionnés si toujours existants
                    if (selectedUpdateId) {
                        this.selectedClientToUpdate = this.clients.find(c => c.id === selectedUpdateId) || null;
                    }
                    if (selectedLockId) {
                        this.selectedClientToLock = this.clients.find(c => c.id === selectedLockId) || null;
                    }
                });
        },
        updateSelectedClientName() {
            if (!this.selectedClientToUpdate || !this.newClientName.trim()) {
                this.errorUpdate = true;
                return;
            }
            console.log("Updating client ID:", this.selectedClientToUpdate, "to new name:", this.newClientName);
            ClientService.updateClientName(this.selectedClientToUpdate, this.newClientName)
                .then(() => {
                    this.newClientName = null;
                    this.errorUpdate = false;
                    this.updateClients();
                })
                .catch(err => {
                    console.error(err);
                    this.errorUpdate = true;
                });
        },
        updateSelectedClientLockState() {
            if (!this.selectedClientToLock) {
                this.errorLock = true;
                return;
            }
            const newLockState = !this.selectedClientToLock.locked;
            ClientService.updateLockStatus(this.selectedClientToLock.id, newLockState)
                .then(() => {
                    this.errorLock = false;
                    this.updateClients();
                })
                .catch(err => {
                    console.error(err);
                    this.errorLock = true;
                });
        },
        addSms() {
            if (this.sms && this.selectedClientSMS) {
                ClientService.addSms(this.selectedClientSMS, this.sms)
                    .then(() => {
                        this.selectedClientSMS = null;
                        this.sms = null;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
    }
}
</script>
